module.exports = __webpack_public_path__ + "img/facebook.a00c9842.svg";